import React from "react";
import "./questions.css";
import config from "../../../config.json";
import Question from "../../../common/Question/Question";

function MobileQuestionsSection() {
  return (
    <section className="flex flex-col questions-wrapper items-center">
      <h4 className="section-title mb-11 text-center">Q&A</h4>
      {config.questions.map((item, i) => (
        <Question item={item} key={i} hideIcon />
      ))}
    </section>
  );
}

export default MobileQuestionsSection;
